import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchRequiredActions } from '../../utilities/dashboardServices'
import { toast } from 'react-toastify'

export const fetchRequiredActionsCPR = createAsyncThunk(
    'fetchRequiredActionsCPR', fetchRequiredActions
)
export const fetchRequiredActionsFAF = createAsyncThunk(
    'fetchRequiredActionsFAF', fetchRequiredActions
)

const initialState = {
    requirdAction:{
        requiredActionFlage:false,
        viewAllFlage:false,
        actionLoader:false,
        allActionData:[],
        requiredActionsValueCPR: [],
        requiredActionsValueFAF: [],
    }
   
}

const requiredActionsSlice = createSlice({
    name: 'requiredActions',
    initialState,
    reducers: {
        resetRequiredActions: (state) => {
            // toast.success("RequiredACtions reseted Successfully")
            state.requirdAction = {
                actionLoader:false,
                viewAllFlage:false,
                requiredActionsValueCPR: [],
                allActionData:[],
                requiredActionsValueFAF: [],
            }
        },
        updateAllActionData:(state,action)=>{
            state.requirdAction.allActionData=action.payload
        },
        updateRequiredActionFlage:(state,action)=>{
            state.requirdAction.requiredActionFlage=action.payload
        },
        setViewAllFlage:(state,action)=>{
            state.requirdAction.viewAllFlage=action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchRequiredActionsCPR.pending, (state, action) => {
                state.requirdAction.actionLoader=true
                // toast.warn("Required Action pending")
            })
            .addCase(fetchRequiredActionsCPR.fulfilled, (state, action) => {
                state.requirdAction.actionLoader=false
                let arr = []
                action.payload.length > 0 && action.payload.map((data) => {
                    let value = {
                        ApplicationID: data.ApplicationID|| "--",
                        PatientName: data?.pxPages?.M?.pyFullName || data?.PatientName|| "--",
                        ActionDescription: data.ActionDescription|| "--",
                        DueDate: data.DueDate|| "--",
                        memberID:data.MemberID || "--"
                    }
                    arr.push(value)
                    state.requirdAction.requiredActionsValueCPR = arr
                })
                // toast.success("Required Action Fetched Successfully")
            })
            .addCase(fetchRequiredActionsCPR.rejected, (state, action) => {
                toast.error(action.error.message)
                state.requirdAction.actionLoader=false
            })
            .addCase(fetchRequiredActionsFAF.pending, (state, action) => {
                // toast.warn("Required Action pending")
                state.requirdAction.actionLoader=true
            })
            .addCase(fetchRequiredActionsFAF.fulfilled, (state, action) => {
                state.requirdAction.actionLoader=false
                let arr = []
                action.payload.length > 0 && action.payload.map((data) => {
                    let value = {
                        ApplicationID: data.ApplicationID|| "--",
                        PatientName: data?.pxPages?.M?.pyFullName || data?.PatientName|| "--",
                        ActionDescription: data.ActionDescription|| "--",
                        DueDate: data.DueDate|| "--",
                        memberID:data.MemberID || "--"
                    }
                    arr.push(value)
                    state.requirdAction.requiredActionsValueFAF = arr
                })
                // toast.success("Required Action Fetched Successfully")
            })
            .addCase(fetchRequiredActionsFAF.rejected, (state, action) => {
                toast.error(action.error.message)
                state.requirdAction.actionLoader=false
            })
    },
})

export const { resetRequiredActions, updateAllActionData, setViewAllFlage,updateRequiredActionFlage } = requiredActionsSlice.actions

export const requiredActions = state => state.requiredActionsSlice.value
export default requiredActionsSlice.reducer